import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import GrowthYouOwn from "./sections/GrowthYouOwn";
import TheEsgDifference from "./sections/TheEsgDifference";
import OurFocusAreas from "./sections/OurFocusAreas";
import TheCoDesignProcess from "./sections/TheCoDesignProcess";
import RealWorldImpact from "./sections/RealWorldImpact";
import LatestInsights from "./sections/LatestInsights";
import ReadyToGrow from "./sections/ReadyToGrow";
import Hero from "./sections/Hero";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <GrowthYouOwn />
      <TheEsgDifference />
      <OurFocusAreas />
      <TheCoDesignProcess />
      <RealWorldImpact />
      <LatestInsights />
      <ReadyToGrow />
      <Hero />
      <Footer />
    </div>;
}